module.exports = __webpack_public_path__ + "img/uk.0fadbd3a.svg";